import styled from "styled-components";

export const LineSectionChartBox = styled.div`
  width: 100%;
  height: 100%;

  .echarts-for-react {
    height: 100% !important;

    & > div:first-child {
      height: 100% !important;
    }
  }
`;
